import HomePage from './Homepage.component';

function HomePageContainer() {
    return ( 
        <HomePage />
    );
}

export default HomePageContainer;